import React from 'react';
export class SignView extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: `${this.props.className} flex-1 max-w-4xl m-6 bg-base-800 border-1 rounded-lg border-base-700 shadow-xl overflow-hidden`, style: this.props.style },
                    React.createElement("div", { className: 'flex flex-col md:flex-row overflow-hidden' },
                        React.createElement("div", { className: 'md:h-auto md:w-1/2' },
                            React.createElement("img", { className: 'object-cover w-full h-full', src: this.props.source })),
                        React.createElement("div", { className: 'flex items-center justify-center p-6 sm:p-12 md:w-1/2 overflow-hidden' },
                            React.createElement("div", { className: 'w-full' }, this.props.children))))));
        };
    }
}
